<script>
import Vue from 'vue'
import date from '../mixins/date'
import MessagesSingle from './MessagesSingle.vue'
import UserResource from '../resources/user'
import MessageResource from '../resources/message'
import DeveloperProfileResource from '../resources/developerprofile'

export default Vue.extend({
    components: {
        MessagesSingle
    },
    mixins: [date],
    props: {
        text: {
            type: String,
            required: false,
            default: ''
        },
    },
    computed: {
        composeMessageToUserResource() {
            return this.$store.getters.composingMessageTo
        },
        userResource() {
            return this.$store.getters.userResource
        }
    },
    data() {
        return {
            loading: true,
            message: this.text,
            recentMessageResources: []
        }
    },
    watch: {
        composeMessageToUserResource() {
            this.getThread()
        },
        recentMessageResources() {
            this.$nextTick(() => {
                this.$nextTick(() => {
                    if(!this.$refs.messages) {
                        return false
                    }
                    
                    this.$refs.messages.scrollTop = this.$refs.messages.scrollHeight
                })
            })
        }
    },
    methods: {
        composeModalClosed() {
            this.$store.commit('composeMessage', null)
            this.message = ''
            this.$emit('close')
        },
        async sendMessage() {
            let message = new MessageResource({ to: this.composeMessageToUserResource.id, content: this.message })
            await message.save()
            this.composeModalClosed()
            this.$store.commit('showMessagesSidebar')
            this.$emit('sent')
        },
        async getThread() {
            if(this.composeMessageToUserResource) {
                this.loading = true
                let content = await MessageResource.thread(this.composeMessageToUserResource.id)
                this.recentMessageResources = content.resources
                this.loading = false
            }
        }
    }
})
</script>

<template>
    <b-modal
        :title="`Message ${composeMessageToUserResource}`"
        @hide="composeModalClosed"
        :visible="!!composeMessageToUserResource"
        ok-title="Send"
        ok-only
        no-fade
        no-close-on-backdrop
        centered>
        <div class="messages" ref="messages" v-if="recentMessageResources.length > 0">
            <messages-single
                v-for="(messageResource, i) in recentMessageResources"
                :key="i"
                :messageResource="messageResource"
                :mine="messageResource.attributes.sender === userResource.id">
            </messages-single>
            <hr />
        </div>
        <b-textarea v-model="message" placeholder="Enter your message here..." />
        <template #modal-footer>
            <b-button @click="sendMessage" variant="primary">Send</b-button>
        </template>
    </b-modal>
</template>

<style lang="scss" scoped>
.messages {
    max-height: 200px;
    overflow-y: scroll;
}
</style>
